<template>
  <section style="height: 100%;">
    <v-app-bar app color="primary" dark>
      <img :src="require('../assets/logo-novaxs-sm.png')" alt="NovaXS" width="30" />

      <v-toolbar-title class="pl-5">Carrinho</v-toolbar-title>
    </v-app-bar>
    <v-subheader
      class="body-1 font-weight-bolder grey lighten-3"
      style="height: 40px !important"
    >Produtos no carrinho</v-subheader>
    <v-divider />
    <v-list v-if="cart.products.length > 0" flat two-line>
      <v-list-item v-for="(item, i) in cart.products" class="pl-1 pr-0" :key="item.title">
        <v-list-item-content>
          <v-list-item-title>
            <v-layout row wrap class="ml-1">
              <v-flex xs1>
                <v-btn @click="del(item, i)" icon x-small>
                  <v-icon color="secondary" class="amount-buttons">mdi-minus</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs1 class="d-flex justify-center">{{ item.amount }}</v-flex>
              <v-flex xs1>
                <v-btn class="amount-btn" @click="add(item)" icon x-small>
                  <v-icon color="secondary" class="amount-buttons">mdi-plus</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs9>{{ item.name }}</v-flex>
            </v-layout>
          </v-list-item-title>
          <v-list-item-subtitle v-html="item.items" class="ml-2"></v-list-item-subtitle>
          <v-list-item-subtitle
            style="text-align: right;"
            v-if="notOnlyDigitalMenu()"
            v-html="item.pdv && item.pdv.availabilityHTML"
          ></v-list-item-subtitle>
          <v-list-item-subtitle style="color: red" v-html="item.memo"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar size="40" class="mr-2">
            <v-img :src="item.image"></v-img>
          </v-avatar>
          <span
            class="body-2"
            style="color: green;"
          >{{$toBrl(parseInt(item.price, 10) * parseInt(item.amount, 10)) }}</span>
        </v-list-item-action>
        <v-list-item-action class="ma-0 pa-0">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon color="grey lighten-1">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="edit(item, i)">
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="remove(i)">
                <v-list-item-title>Remover</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-sheet v-else class="fill-height d-flex align-center justify-center">
      <v-layout column justify-center>
        <v-flex class="d-flex justify-center">
          <v-icon color="grey" size="60">local_dining</v-icon>
        </v-flex>
        <v-flex class="d-flex justify-center">
          <span class="subheading grey--text">Não há nenhum produto em seu carrinho</span>
        </v-flex>
      </v-layout>
    </v-sheet>
    <v-footer app padless>
      <v-divider></v-divider>
      <v-btn
        style="width: 100%"
        color="secondary"
        tile
        depressed
        @click="$router.push({ name: 'categories' })"
      >continue comprando</v-btn>
      <v-list-item>
        <v-list-item-content style="padding: 0">
          <v-list-item-title style="text-align: right">Total: {{ $toBrl(parseInt(total, 10)) }}</v-list-item-title>
          <v-list-item-subtitle v-if="notOnlyDigitalMenu()" style="text-align: right">
            Saldo:
            {{
            visit && visit.balance
            ? $toBrl(parseInt(visit.balance, 10))
            : "R$ 0,00"
            }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-btn
        color="secondary"
        block
        text
        tile
        x-large
        @click="finish()"
        :disabled="cart.products.length === 0 || finishing"
      >
        <span>{{ $toBrl(parseInt(total, 10)) }}</span>
        <span class="add">enviar pedido</span>
      </v-btn>
    </v-footer>
    <v-dialog v-model="visible" width="500" max-width="350">
      <v-card>
        <v-card-title class="headline">Finalizar Pedido</v-card-title>
        <v-card-text>Digite a senha da sua mesa para finalizar o pedido</v-card-text>
        <v-form @submit.prevent style="padding: 15px;">
          <v-flex>
            <v-text-field type="password" v-model="password" label="Senha" v-on:keyup.enter="confirm()"></v-text-field>
          </v-flex>
          <v-flex style="text-align: right; padding-top: 15px">
            <v-btn :loading="finishing" class="accent" @click="confirm()">Confirmar</v-btn>
          </v-flex>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import VisitService from "../services/visitService";
import OrderService from "../services/orderService";
import SettingsService from "../services/settingsService";

export default {
  data() {
    return {
      total: 0,
      cart: {
        products: []
      },
      visit: { products: [] },
      finishing: false,
      visible: false,
      password: ""
    };
  },
  mounted() {
    this.finishing = false;
    if (localStorage.getItem("cart"))
      this.cart = JSON.parse(localStorage.getItem("cart"));
    if (this.cart.products) {
      this.cart.products.forEach(product => {
        console.log(product)
        product.items = "";
        if (product.products){
          product.products.forEach(p =>{
            let str = ""
            if (p.product.product_accompaniments)
              p.product.product_accompaniments.forEach(additional => {
                console.log(additional)
                additional.accompaniment_category.accompaniments.forEach(a =>{
                    if(a.active)
                      str += a.option.name + ", ";
                  })
              });
            if (p.product.product_additionals)
              p.product.product_additionals.forEach(additional => {
                additional.additional_category.additionals.forEach(a =>{
                    if(a.active)
                      str += a.option.name + ", ";
                  })
              });
            if (p.product.product_optionals)
              p.product.product_optionals.forEach(additional => {
                additional.optional_category.optionals.forEach(a =>{
                    if(a.active)
                      str += a.option.name + ", ";
                  })
              });
            if (str.length > 2){
              str = str.substring(0, str.length - 2);
              str =": " + str;
            }
            str = p.product.name + str;
            if (str.length > 0){
              str += "</br>"
              product.items += str;
            }
          })
          return;
        }
        if (product.accompaniments)
          product.accompaniments.forEach(accompaniment => {
            product.items += accompaniment.option.name + ", ";
          });
        if (product.additionals)
          product.additionals.forEach(additional => {
            product.items += additional.option.name + ", ";
          });
        if (product.optionals)
          product.optionals.forEach(optional => {
            product.items += optional.option.name + ", ";
          });
        if (product.items.length > 2)
          product.items = product.items.substring(0, product.items.length - 2);
      });
      this.calcule();
    }
    this.getActiveVisitByCardNumber();
  },
  methods: {
    notOnlyDigitalMenu() {
      return localStorage.getItem("onlyDigitalMenu").toString() !== "true";
    },
    edit(item, i) {
      this.$router.push({
        name: item.products ? "product-combo": "product",
        params: { product: item, id: item.id, cartIndex: i }
      });
    },
    remove(i) {
      this.$confirm("Tem certeza que deseja remover o produto?", () => {
        this.cart.products.splice(i, 1);
        localStorage.setItem("cart", JSON.stringify(this.cart));
        this.calcule();
      });
    },
    add(item) {
      item.amount++;
      this.calcule();
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    del(item, i) {
      if (item.amount === 1) {
        this.remove(i);
        this.calcule();
        localStorage.setItem("cart", JSON.stringify(this.cart));
        return;
      }
      item.amount--;
      this.calcule();
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    calcule() {
      this.total = 0;
      this.cart.products.forEach(item => {
        this.total += parseInt(item.price, 10) * parseInt(item.amount, 10);
      });
    },
    async finish() {
      const res = await new SettingsService().getByKey("onlyDigitalMenu");
      const settings = res.data;
      let onlyDigitalMenu = false;
      if (settings && settings.length) {
        if ("true" === settings[0].value.toString()) onlyDigitalMenu = true;
      }

      if (onlyDigitalMenu) {
        this.visible = true;
      } else {
        this.finishing = true;
        this.$router.push({ name: "identify" });
      }
    },
    async confirm() {
      try {
        this.finishing = true;
        await new OrderService().finishOrdersOnlyDigital(
          this.mountOrderOnlyDigitalMenu()
        );

        this.$info("Pedido realizado");

        if (localStorage.getItem("order") == null)
          localStorage.setItem("order", JSON.stringify({ products: [] }));
        const products = JSON.parse(localStorage.getItem("order")).products;
        this.cart.products.forEach(product => {
          const p = {
            amount: product.amount,
            name: product.name,
            orderID: "",
            price: parseInt(product.price, 10) * parseInt(product.amount, 10),
            pdv: {
              name: product.pdv.name
            }
          };
          products.push(p);
        });
        localStorage.setItem("order", JSON.stringify({ products: products }));

        this.visible = false;
        this.$options.data.apply(this);
        localStorage.removeItem("cart");
        this.$router.push({ name: "categories" });
        this.finishing = false;
      } catch (e) {
        let message = "";
        if (e.response && e.response.data && e.response.data.message)
          message = e.response.data.message;
        this.$info("Erro ao finalizar pedido!", message, "error");
        this.finishing = false;
        this.visible = false;
      }
    },
    mountOrderOnlyDigitalMenu() {
      let pdvs = [];
      this.cart.products.forEach(product => {
        if (
          pdvs.indexOf(pdvs.filter(pdv => pdv.id === product.pdv.id)[0]) === -1
        )
          pdvs.push(product.pdv);
      });
      const orders = [];
      pdvs.forEach(async pdv => {
        const order = {
          access_point_id: JSON.parse(localStorage.getItem("accessPoint")).id,
          pdv_id: parseInt(pdv.id, 10),
          visit: {
            access_point_id: JSON.parse(localStorage.getItem("accessPoint")).id,
            card: {
              password: this.password
            }
          },
          entries: []
        };
        const products = this.cart.products.filter(
          product => product.pdv.id === pdv.id
        );
        products.forEach(product => {
          let entry = order.entries.filter(e => e.product_id === product.id)[0];
          if (entry == null) {
            entry = {
              product_id: product.products ? 0: product.id,
              product_combo_id:  product.products ? product.id: 0,
              product:product.products ? {} : {
                id: parseInt(product.id, 10),
                price: parseInt(product.originalPrice, 10)
              },
              entries: product.products ? this.generateEntries(product) : [],
              options: []
            };
            entry.amount = product.amount;
            this.addEntryOptions(entry, product);
            order.entries.push(entry);
          } else {
            entry.amount =
              parseInt(entry.amount, 10) + parseInt(product.amount, 10);
            for (let i = 0; i < product.amount; i++) {
              const option = {
                memo: product.memo
              };
              entry.options.push(option);
            }
          }
          entry.price =
            parseInt(product.price, 10) * parseInt(product.amount, 10);
        });
        orders.push(order);
      });
      return orders;
    },
    addEntryOptions(entry, product) {
      const option = {
        memo: product.memo,
        accompaniments: [],
        additionals: [],
        optionals: []
      };
      product.accompaniments.forEach(accompaniment => {
        option.accompaniments.push({
          item_id: parseInt(accompaniment.id, 10),
          item: {
            id: parseInt(accompaniment.id, 10),
            option: {
              name: accompaniment.option.name
            }
          }
        });
      });
      product.additionals.forEach(additional => {
        option.additionals.push({
          item_id: parseInt(additional.id, 10),
          item: {
            id: parseInt(additional.id, 10),
            price: parseInt(additional.price, 10),
            option: {
              name: additional.option.name
            }
          }
        });
      });
      product.optionals.forEach(optional => {
        option.optionals.push({
          item_id: parseInt(optional.id, 10),
          item: {
            id: parseInt(optional.id, 10),
            option: {
              name: optional.option.name
            }
          }
        });
      });
      entry.options.push(option);
    },
    async getActiveVisitByCardNumber() {
      const res = await new VisitService().getActiveVisitsByID();
      this.visit = res.data || { orders: [] };
      if (this.visit.id === 0) {
        localStorage.removeItem("visit");
        localStorage.removeItem("consumptionCard");
      }
      this.visit.products = [];
      this.visit.orders = this.visit.orders.sort((a, b) => b.id - a.id);
      this.visit.orders.forEach(order => {
        if (order.entries) {
          order.entries.forEach(entry => {
            this.visit.products.push({
              ...entry.product,
              amount: entry.amount,
              price: entry.price,
              pdv: order.pdv,
              orderID: order.id
            });
          });
        }
      });
    },
    generateEntries(product) {
      let entries =  [];
      product.products.forEach( pro =>{
        let productCombo = {
          id:pro.product.id,
          amount: 1,
          options: {
            accompaniments :[],
            additionals:[],
            optionals:[]
          }
        }
        if (pro.product.product_accompaniments)
          pro.product.product_accompaniments.forEach(additional => {
            console.log(additional)
            additional.accompaniment_category.accompaniments.forEach(a =>{
              if(a.active)productCombo.options.accompaniments.push({
                option_id:a.option_id
              })
            })
          });
        if (pro.product.product_additionals)
          pro.product.product_additionals.forEach(additional => {
            additional.additional_category.additionals.forEach(a =>{
              if(a.active)productCombo.options.additionals.push({
                option_id:a.option_id
              })
            })
          });
        if (pro.product.product_optionals)
          pro.product.product_optionals.forEach(additional => {
            additional.optional_category.optionals.forEach(a =>{
              if(a.active)productCombo.options.optionals.push({
                option_id:a.option_id
              })
            })
          });
      })
      return entries;
    }
  }
};
</script>

<style>
/*.cart-product-list {*/
/*  height: calc(100vh - 157px) !important;*/
/*  overflow: scroll;*/
/*}*/
/*.cart-product-list .v-list .v-list-item {*/
/*  padding-right: 0 !important;*/
/*}*/
/*.cart-product-list .v-list .v-list-item .v-list-item__subtitle {*/
/*  padding-right: 15px;*/
/*}*/
/*.cart-product-list .v-list .v-list-item .v-list-item__action {*/
/*  margin-left: 0 !important;*/
/*}*/
/*.overflow-subtitle {*/
/*  display: flex !important;*/
/*  text-justify: inter-word !important;*/
/*  text-align: justify !important;*/
/*}*/
/*.amount-buttons {*/
/*  font-size: 15px !important;*/
/*  height: auto !important;*/
/*  min-height: auto !important;*/
/*  min-width: auto !important;*/
/*}*/
/*.amount-btn {*/
/*  height: auto !important;*/
/*  min-width: auto !important;*/
/*}*/
.v-list-item__title {
  white-space: normal !important;
}
</style>
